import { buildQuery } from '@calendly/http-tools'

import { pushQueryParams } from 'actions/core/navigation'
import { Periods } from 'constants/scheduling'
import { useQueryParams } from 'hooks/use_query_params'

const DATE_RANGE_KEYS = [
  'start_date',
  'end_date'
]

const pickProps = (from, allowListedProps) => (
  allowListedProps.reduce((accumulator, currentValue) => {
    accumulator[currentValue] = from[currentValue]
    return accumulator
  }, {})
)

const buildPeriodProps = (params) => (
  Object.values(Periods).includes(params.period) ? params.period : Periods.ALL_TIME
)

const buildFilterParams = (params) => ({
  period: buildPeriodProps(params),
  event_type_ids: params.event_type_ids || [],
  ...pickProps(params, DATE_RANGE_KEYS),
  ...(params.page && { page: params.page })
})

const buildItemParams = (filterName, ids) => {
  const newIds = Object.values(ids).flat().filter((id) => id !== 'any')
  if (!newIds.length) {
    newIds.push('any')
  }
  return {
    [`${filterName}_ids`]: newIds
  }
}

export const useFilters = () => {
  const queryParams = useQueryParams()

  const getFilterParams = () => (
    buildFilterParams(queryParams)
  )

  const applyPeriod = (type, { start_date: startDate, end_date: endDate } = {}) => (dispatch) => {
    const oldParams = buildFilterParams(queryParams)
    const params = {
      ...oldParams,
      period: type,
      ...(startDate && { start_date: startDate }),
      ...(endDate && { end_date: endDate })
    }

    dispatch(pushQueryParams(params))
  }

  // low level methods used to apply filter with limit check
  const buildApplyFilterParams = (filterName, ids) => {
    const oldParams = buildFilterParams(queryParams)
    const itemParams = buildItemParams(filterName, ids)
    const newParams = {
      ...oldParams,
      ...itemParams
    }
    delete newParams.page
    return newParams
  }

  const isValidApplyParams = (params) => {
    const query = buildQuery(params)
    return query.length < 2000
  }

  const applyFilterParams = (params) => (dispatch) => {
    dispatch(pushQueryParams(params))
  }

  // without limit check
  const applyFilter = (filterName, ids) => (dispatch) => {
    const newParams = buildApplyFilterParams(filterName, ids)
    dispatch(applyFilterParams(newParams))
  }

  return {
    getFilterParams,
    applyPeriod,
    buildApplyFilterParams,
    isValidApplyParams,
    applyFilterParams,
    applyFilter
  }
}
